import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MobileMenu from "./MobileMenu"; // pastikan path-nya sesuai

const HeaderComponent = () => {
    const location = useLocation();
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

    const toggleNav = () => {
        console.log("Toggle Mobile Nav:", !isMobileNavOpen);
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const closeMobileNav = () => {
        if (isMobileNavOpen) {
            setIsMobileNavOpen(false);
        }
    };

    return (
        <>
            <header id="header" className="fixed-top header-transparent">
                <div className="container d-flex align-items-center justify-content-between">
                    <div className="logo">
                        <a href="#">
                            <img src={`${process.env.PUBLIC_URL}/sampang.png`} alt="Sampang" />
                        </a>
                    </div>
                    {/* Untuk tampilan desktop */}
                    <nav id="navbar" className="navbar d-none d-lg-block">
                        <ul>
                            <li>
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#open_data" ? "active" : ""}`}
                                    href="#open_data"
                                >
                                    Open Data
                                </a>
                            </li>
                            {/* <li>
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#dashboard" ? "active" : ""}`}
                                    href="#dashboard"
                                >
                                    Dashboard
                                </a>
                            </li> */}
                            <li>
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#peta_digital" ? "active" : ""}`}
                                    href="#peta_digital"
                                >
                                    Peta Digital
                                </a>
                            </li>
                            <li className="dropdown">
                                <a
                                    className={`nav-link scrollto ${location.pathname === "/#statistik_sektoral" ? "active" : ""}`}
                                    href="#statistik_sektoral"
                                    onClick={closeMobileNav}
                                >
                                    <span>Statistik Sektoral</span> <i className="bi bi-chevron-down"></i>
                                </a>
                                <ul>
                                    <li>
                                        <a href="https://romantik.web.bps.go.id/" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                            Rekomendasi Statistik
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://indah.bps.go.id/" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                            Metadata Statistik
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.bps.go.id/id/publication/2026/01/15/c733974d5ab8e5901826c2a8/standar-data-statistik-2025.html" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                            Standar Data Statistik
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://diskominfo.sampangkab.go.id/unit-kerja/SDP?page=sop" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                            SOP
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://short.sampangkab.go.id/851526-42992" onClick={closeMobileNav}>Buku Pedoman</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </nav>

                    {/* Tombol toggle untuk mobile */}
                    <i
                        className={`bi mobile-nav-toggle d-lg-none ${isMobileNavOpen ? "bi-x" : "bi-list"}`}
                        onClick={toggleNav}
                    ></i>
                </div>
            </header>

            {/* Render MobileMenu menggunakan Portal */}
            <MobileMenu isOpen={isMobileNavOpen} closeMobileNav={closeMobileNav} location={location} />
        </>
    );
};

export default HeaderComponent;